import { useMounted } from '@mantine/hooks'
import { Fragment, type ReactNode } from 'react'

/**
 * Port of cdc-web `src/components/basic/HydrationSafe.tsx`（1:1 语义）。
 * 首帧（SSR + hydration）渲染占位 key='server'，挂载后切换 key 强制重挂载子树，
 * 避免"客户端本地时区格式化的时间标签"与 SSR 输出不一致导致的 hydration mismatch。
 * cdc-market 直接从 `@mantine/hooks` 拿 `useMounted`（已有先例见 src/hooks/responsive.ts）。
 */
export function HydrationSafe({ children }: Readonly<{ children: ReactNode }>) {
  const isMounted = useMounted()
  return <Fragment key={isMounted ? 'client' : 'server'}>{children}</Fragment>
}
